export default __webpack_public_path__ + "static/media/rock.d1479bba.mp3";